import React, {useContext, useEffect, useState} from "react";
import {Link} from 'react-router-dom'

import Container from "react-bootstrap/Container";
import FarmNFT from "../components/FarmNFT";

import {Web3Context, ContractsContext} from "../contexts/Context";

import Logger from "../components/utils/Logger";

import Paginator from "../components/common/Paginator";

const Farm = () => {
  const web3Context = useContext(Web3Context);
  const contractsContext = useContext(ContractsContext);

  const itemsPerPage = 4;
  const [visibleNfts, setVisibleNfts] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    Logger.log("useEffect Farm");
    const {contractNiftyEggsFarmer} = contractsContext;

    const loadNfts = async () => {
      try {
        if (contractNiftyEggsFarmer) {
          const numberOfNftFarms = await contractNiftyEggsFarmer.methods.getNumberOfNftFarms().call();

          let items = [];
          for (let i = 0; i < numberOfNftFarms; i++) {
            const item = await contractNiftyEggsFarmer.methods.getNftFarmInfo(i).call();
            items.push(item);
          }

          Logger.log("Loaded FarmNFT farms", items);

          if (!items || items.length === 0) {
            setPageCount(0);
            return;
          }

          setPageCount(Math.ceil(items.length / itemsPerPage));
          const offset = currentPage * itemsPerPage;
          setVisibleNfts(items.slice(offset, offset + itemsPerPage));
        }
      }
      finally {
        setIsInitialized(true);
      }
    };

    loadNfts();
  }, [web3Context, contractsContext, currentPage]);

  if (!visibleNfts || visibleNfts.length === 0) {
    const text = isInitialized ? "No NFTs to farm yet!" : "Loading...";
    return (
      <div className="px-4 py-5 container-fluid">
        <div className="row no-gutters">
          <div className="col-12 col-md-10 offset-md-1 text-center">    
            <h4>{text}</h4>
          </div>
        </div>
      </div>
    )
  }

  const listItems = visibleNfts.map((item, index) =>
    <FarmNFT key={index} nft={item}/>
  );

  return (
    <div className="px-4 py-5 container-fluid">
      <div className="row no-gutters">
        <div className="col-12 col-md-10 offset-md-1 text-center">    
          <h2 className="mb-4">Farm NiftyEggs</h2>
          <p>( <span className="text-warning">Tip #1: </span>NiftyEggs that you are already farming can be found in <Link className="text-white" to="/inventory">NiftyEggs</Link> page. )</p>
          <p>( <span className="text-warning">Tip #2: </span>Press on the egg to see the full NFT image. )</p>
          <p>( <span className="text-danger">Tip #3: </span>ERC20 tokens that have a transfer fee are not supported. Please do not use them! )</p>
          <Container className="mt-5">
            <div className="mb-4">
              <Paginator pageCount={pageCount} setCurrentPage={setCurrentPage} currentPage={currentPage} />
            </div>
            {listItems}
            <Paginator pageCount={pageCount} setCurrentPage={setCurrentPage} currentPage={currentPage} />
          </Container>
        </div>
      </div>
    </div>
  )
};

export default Farm;